import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { Field, FormError, SubmitButton, TextInput } from "@/components/inquiry/fields";
import { Logo } from "@/components/site/Logo";
import { FullscreenLoader, useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user === null) return <FullscreenLoader />;
  if (user) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grid min-h-screen place-items-center bg-brand-mist px-4">
      <div className="w-full max-w-md overflow-hidden rounded-3xl bg-white shadow-lift" data-testid="admin-login-card">
        <div className="bg-brand-yellow px-8 py-6"><Logo testId="admin-login-logo" /></div>
        <form onSubmit={onSubmit} className="space-y-5 p-8" noValidate>
          <div className="flex items-center gap-2">
            <Lock className="h-5 w-5 text-brand-blue" />
            <h1 className="text-xl font-bold text-brand-anthracite">Admin-Anmeldung</h1>
          </div>
          <Field label="E-Mail" required htmlFor="login-email">
            <TextInput id="login-email" type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email-input" />
          </Field>
          <Field label="Passwort" required htmlFor="login-password">
            <TextInput id="login-password" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password-input" />
          </Field>
          <FormError error={error} testId="login-error" />
          <SubmitButton loading={loading} testId="login-submit-button">Anmelden</SubmitButton>
        </form>
      </div>
    </div>
  );
}
